import {apiUrl} from '../../config/net'
const index = `${apiUrl}/v0/onlinemall/mobile/address`

export default {
  index
}



// WEBPACK FOOTER //
// ./src/model/user-address/resource-url.js